import { cn } from '@/utils'
import { IconTemplate } from '@tabler/icons-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface ScalrEmptyBoxProps {
  message?: string
  title?: string
  icon?: React.ComponentType<{ size?: number; className?: string }>
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export const ScalrEmptyBox: React.FC<ScalrEmptyBoxProps> = ({
  message,
  title,
  icon: Icon = IconTemplate,
  className,
  size = 'md',
}) => {
  const { t } = useTranslation()

  const displayTitle = title ?? t('emptyStates.emptyPage')
  const displayMessage = message ?? t('emptyStates.noData')
  const sizeClasses = {
    sm: {
      container: 'py-8 px-4',
      icon: 48,
      title: 'text-lg',
      message: 'text-sm',
    },
    md: {
      container: 'py-12 px-6',
      icon: 64,
      title: 'text-xl',
      message: 'text-base',
    },
    lg: {
      container: 'py-16 px-8',
      icon: 80,
      title: 'text-2xl',
      message: 'text-lg',
    },
  }

  const currentSize = sizeClasses[size]

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        currentSize.container,
        className
      )}
    >
      <Icon size={currentSize.icon} className="text-muted-foreground/50 mb-4" />
      <h3
        className={cn(
          'font-semibold text-muted-foreground mb-2',
          currentSize.title
        )}
      >
        {displayTitle}
      </h3>
      <p
        className={cn('text-muted-foreground/80 max-w-sm', currentSize.message)}
      >
        {displayMessage}
      </p>
    </div>
  )
}

export default ScalrEmptyBox
